<div class="app-container">
    <div app-navbar></div>
    <div class="app-main-body">
        <div class="app-main-content">
            <div class="app-sidebar">
                <div app-sidebar></div>
            </div>
            <div class="app-content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <div class="app-footer">
    </div>
</div>